
import Vue from 'vue'

export default Vue.extend({
  name: 'JcdcFormGroup',
  props: {
    header: { type: String, default: undefined },
    dense: { type: Boolean, default: false },
  },
})
